import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_BACKEND_URL}`;
// const apiUrl = 'http://192.168.1.6:5000';
// const apiKey = 'api_key=8c247ea0b4b56ed2ff7d41c9a833aa77';
// Get Popular Movies
export const getRecentsPost = async () => {
  const resp = await axios.get(`${apiUrl}/api/dash/recents`);
  return resp.data;
};

// Get Upcoming Movies
export const getPosts = async () => {
  const resp = await axios.get(`${apiUrl}/api/posts`);
  return resp.data.posts;
};

// Get Popular TV
export const getPopularsPost = async () => {
  const resp = await axios.get(`${apiUrl}/api/dash/popular`);
  return resp.data;
};

// Get Family Movies
export const getExlusifsPost = async () => {
  const resp = await axios.get(
    `${apiUrl}/api/dash/exclusif`,
  );
  return resp.data;
};


export const getSignlePost = async id => {
  const resp = await axios.get(`${apiUrl}/api/posts/byid/${id}`);
  return resp.data.data;
};

// Get Categories
export const getCategories = async () => {
  const resp = await axios.get(`${apiUrl}/api/categories`);
  return resp.data.data;
};

// Search for Movie or TV by Keyword
export const searchPosts = async (params) => {
  const resp = await axios.get(
    `${apiUrl}/api/posts/search?${params}`,
  );
  return resp.data;
};
